import React, { useEffect } from 'react';
import s from './Security.module.css';

const Security = () => {
    return <div>Security</div>;
};

export default Security;
